import {createBrowserHistory} from 'history'
import 'url-search-params-polyfill'

export default createBrowserHistory()
